module.exports = __webpack_public_path__ + "static/media/mm.a0103549.svg";